// extracted by mini-css-extract-plugin
export default {"header":"header-a3995aaf","button":"button-ce2bcc0f","rounded":"rounded-d9e010c6","light":"light-bc7c2a62"};